import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {SessionService} from 'src/app/services/session.service';
import {saveAs} from 'file-saver';
import {DataService, DatasetBannerModel} from 'src/app/services/data.service';
import {DialogService} from 'src/app/services/dialog.service';
// Rxjs
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, switchMap, tap, filter, distinctUntilChanged} from 'rxjs/operators';
import {FileService} from 'src/app/services/file.service';
import {KeyValue} from '@angular/common';

@Component({
  selector: 'app-enterprise-mlmodels',
  templateUrl: './enterprise-mlmodels.component.html',
  styleUrls: ['./enterprise-mlmodels.component.scss']
})
export class EnterpriseMlModelsComponent implements OnInit {
  private params: Params;
  datasetId = 0;
  dataset: any = false;
  isReady = false;
  devMode = false;
  datasetName = '';
  elements: any = [];
  bestModal = [];
  geneartingEnsembler = false;
  donwloadingEnsembler = false;
  canGenerateEnsembler = false;
  canGenerateInsight = false;
  isChallengeDataset = false;
  meta: any = {
    total: 0,
    nb_page: 1,
    current_page: 1,
    first_page: 1,
    last_page: 1,
    count: 0,
    per_page: 20,
  };
  modelType = null;
  confusionMatrix = [[0, 0], [0, 0]];
  scoreView = false;
  chart = null;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private dialogService: DialogService,
              private trustiiService: TrustiiService,
              private sessionService: SessionService,
              public datasetBannerModel: DatasetBannerModel,
              private dataservice: DataService,
              public fileService: FileService) {
  }

  /**
   * Init component
   *
   * @return void
   */
  ngOnInit(): void {
    this.devMode = !environment.production;
    this.canGenerateInsight = this.sessionService.canGenerateInsight();
    this._loadParams$().pipe(
      switchMap(this._loadDataset$.bind(this)),
      tap(this.getMlModels.bind(this))
    ).subscribe();
  }

  private _loadParams$(): Observable<Params> {
    return this.route.params
      .pipe(
        map((params: Params) => this.params = params)
      );
  }

  private _loadDataset$(): Observable<any> {
    if (!this.params.datasetId || this.params.datasetId <= 0) {
      return of({});
    }
    this.datasetId = this.params.datasetId;
    return this.trustiiService.getDataset(this.datasetId)
      .pipe(
        map((dataset: any) => this.dataset = dataset.data),
        tap(() => {
          this.isChallengeDataset = (this.dataset.category !== 'default');
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  getMlModels(): void {
    this.dataservice.data.trainigData = this.datasetId;
    this.trustiiService.getMlModels(this.datasetName, this.datasetId, this.meta.page, this.meta.per_page).subscribe(
      (res) => {
        this.meta = res.meta;
        this.bestModal = res.data.filter(model => model.type === 'best');
        const autoML = res.data.filter(model => model.type === 'auto');
        this.elements = (this.isChallengeDataset && autoML.length > 0) ? [autoML[0]].concat(this.bestModal) : autoML.concat(this.bestModal);
        if (this.isChallengeDataset && this.elements.length > 0 && this.elements[0].type === 'auto') {
          this.elements[0].displayName = 'Challenge Baseline Model – Trustii Auto ML';
        }
        this.getInsights();
      },
      (err) => {
        this.isReady = true;
        this.elements = [];
      }
    );
  }

  showInsights(modelId: number): void {
    this.dataservice.data.modelId = modelId;
    // todo modelId is currently not used since backend does not have filter based on modelId
    // TODO change route
    this.router.navigateByUrl('enterprise/datasets/' + 0 + '/insights');
  }

  getInsights(): void {
    this.trustiiService.getInsights('', 0, this.meta.page, this.meta.per_page).subscribe(
      (insightResponse) => {
        this.elements.forEach(model => {
          const findInsights = insightResponse.data.filter(item => item.mlModelId === model.id);
          findInsights.length > 0 ? model.insightsAvailable = true : model.insightsAvailable = false;
        });
        if (this.bestModal.length > 0) {
          this.bestModal.forEach(model => {
            const findInsights = insightResponse.data.filter(item => item.mlModelId === model.id);
            findInsights.length > 0 ? model.insightsAvailable = true : model.insightsAvailable = false;
          });
        }
        this.isReady = true;
      },
      (insightError) => {
        this.isReady = true;
        // this.elements = [];
      }
    );
  }

  downloadModelEnsembleModel(mlModelId: number) {
    this.donwloadingEnsembler = true;
    this.trustiiService.getMLModel(mlModelId).subscribe(res => {
      if (res.data.status === 'in-progress') {
        this.downloadModelEnsembleModel(mlModelId);
        return;
      } else {
        this.trustiiService.downloadMLModel(mlModelId).subscribe(response => {
          if (response.status === 'progress') {
          } else if (response.status === 'error') {
            this.dialogService.openAlertDialog(
              '350px',
              'Failed to download Trustii Ensembler',
              'ERROR',
              'Ok',
              'modal-warning'
            );
          } else if (response.size &&
            response.type === 'application/octet-stream') {
            this.donwloadingEnsembler = false;
            saveAs(response, res.data.displayName + '.joblib');
          }
        }, (err) => {
          this.donwloadingEnsembler = false;
          this.dialogService.openAlertDialog(
            '350px',
            'failed to download Trustii Ensembler.',
            'ERROR',
            'Ok',
            'modal-warning'
          );
        });
      }
    }, (err) => {
      this.donwloadingEnsembler = false;
      this.dialogService.openAlertDialog(
        '350px',
        'failed to download Trustii Ensembler.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
    });
  }

  downloadModel(mlModelId: number): void {
    this.elements.find(item => item.id === mlModelId).downloading = true;
    this.elements.find(item => item.id === mlModelId).downloadProgress = 0;
    this.trustiiService.getMLModel(mlModelId).subscribe(res => {
      if (res.data.status === 'in-progress') {
        this.downloadModel(mlModelId);
        return;
      } else {
        this.trustiiService.downloadMLModel(mlModelId).subscribe(response => {
          if (response.status === 'progress') {
            this.elements.find(item => item.id === mlModelId).downloadProgress = response.message;
          } else if (response.status === 'error') {
            this.elements.find(item => item.id === mlModelId).downloading = false;
            this.dialogService.openAlertDialog(
              '350px',
              'Failed to download model ' + this.elements.find(item => item.id === mlModelId).displayName,
              'ERROR',
              'Ok',
              'modal-warning'
            );
          } else if (response.size &&
            response.type === 'application/octet-stream') {
            this.elements.find(item => item.id === mlModelId).downloading = false;
            saveAs(response, res.data.displayName + '.joblib');
          }

        }, (err) => {
          this.dialogService.openAlertDialog(
            '350px',
            'Failed to download model ' + this.elements.find(item => item.id === mlModelId).displayName,
            'ERROR',
            'Ok',
            'modal-warning'
          );
        });
      }
    }, (err) => {
      this.elements.find(item => item.id === mlModelId).downloading = false;
      this.dialogService.openAlertDialog(
        '350px',
        'Failed to download model ' + this.elements.find(item => item.id === mlModelId).displayName,
        'ERROR',
        'Ok',
        'modal-warning'
      );
    });
  }

  /**
   * Generate preditctions
   *
   * @param options.modelId Dataset ID
   */
  generatePredictions(options): void {
    if (!options.that.sessionService.canGenerateInsight(options.that.fileService.file.size)) {
      options.that.dialogService.openAlertDialog('You have reached the prediction limit', 'FORBIDDEN');
      return;
    }
    if (options.that.sessionService.willReachInsightLimit(options.that.fileService.file.size)) {
      const message = 'You will reach your prediction limit for this month, if you continue you will pay extra fees. Do you confirm ?';
      options.that.dialogService.openConfirmDialog(message).pipe(
        distinctUntilChanged(),
        filter((result: any) => result && result.data === 'confirmation'),
        tap(() => options.that.runModel(options.modelId))
      ).subscribe();
      return;
    }
    options.that.runModel(options.modelId);
  }

  runModel(modelId): void {
    this.dataservice.data.trainigData = this.datasetId;
    this.dataservice.data.modelId = modelId;
    this.dataservice.data.mlProblem = this.dataset.mlProblem;
    this.router.navigateByUrl('enterprise/mlmodels/' + modelId + '/insights/generate');
  }

  generateModel(): void {
    this.dataservice.setData(this.dataset);
    this.router.navigateByUrl('enterprise/datasets/' + this.dataset.id + '/configuration');
  }

  /**
   * When limit changed
   *
   * @param perPage Nb result per page
   */
  onLimitChanged(perPage: number): void {
    this.meta.per_page = perPage;
    this.getMlModels();
  }

  /**
   * When page changed
   *
   * @param page The page
   */
  onPageChanged(page: number): void {
    this.meta.page = page;
    this.getMlModels();
  }

  /**
   * Format date
   *
   * @param stringDate The date
   * @return Local date
   */
  formatDate(stringDate: string): string {
    const date = new Date(stringDate);
    return date.toLocaleString();
  }

  /**
   * Load the testModel route
   *
   * @param mlModelId ML Model ID
   */
  testModel(mlModelId: number): void {
    if (!this.canGenerateInsight) {
      return;
    }
    this.dataservice.data = {modelId: mlModelId, trainigData: this.datasetId};
    this.router.navigateByUrl('enterprise/test');
  }

  // Order by descending property value
  sortByValue = (a: KeyValue<string, number>, b: KeyValue<string, number>): number => {
    return b.value - a.value;
  }

  loadRunModelWiki() {
    window.open('https://colab.research.google.com/gist/Trustii-team/1a8d721d1e8cb5d4da6b34954a451ce0/' +
      'run-your-first-trustii-model.ipynb');
  }

  generateEnsembler(e) {
    this.geneartingEnsembler = true;
    this.trustiiService.buildMLModel(this.params.datasetId, 'best').subscribe(res => {
        if ('in-progress' === res.data.status) {
          this.getMlModel(res.data.id);
        } else {
          this.geneartingEnsembler = false;
        }
      },
      (err) => {
        this.geneartingEnsembler = false;
        this.dialogService.openAlertDialog(
          '350px',
          'Failed to generateModel ensamble model',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      });
  }

  showLeaderboard(e) {
    this.router.navigateByUrl('leaderboard/' + this.dataset.id);
    Object.assign(this.datasetBannerModel.dataset, this.dataset);
    Object.assign(this.dataservice.data, this.dataset);
    this.router.navigateByUrl('datasets/' + this.dataset.id);
  }

  getMlModel(modelId) {
    this.geneartingEnsembler = true;
    this.trustiiService.getMLModel(modelId).subscribe(res => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getMlModel(modelId);
          }, 10 * 1000); // poll every 10 seconds
        } else {
          this.geneartingEnsembler = false;
          this.bestModal = res.data;
          this.router.navigateByUrl('leaderboard/' + this.params.datasetId);
        }
      },
      (err) => {
        this.geneartingEnsembler = false;
      });
  }

  backToDataset() {
    this.router.navigateByUrl('enterprises/datasets');
  }
}
